module.exports = {
  env: 'production',
  appRoot: '/partners-widgets',
  credibleRoot: 'https://www.credible.com',
  graphqlUri: 'https://www.credible.com/api/graphql',
  bowtieProxyRoot: 'https://www.credible.com',
  bowtieProxyUrl: '/credible-bowtie-proxy/api/v1',
  cognitoUserPoolID: 'us-east-1_9fCLAuWkj',
  cognitoClientID: '1jkfo8n3j7tpgkinbff5r8u8c',
  cognitoCookieExpires: 1,
  imageResizePath: '/images',
  snowplowEndpoint: 'analytics.credible.com',
  snowplowAppId: 'credible-partners-widgets-production',
  snowplowEncodeBase64: false,
  gtmContainerId: 'GTM-W5CPLQC',
  ratesLibraryUrl: 'https://www.credible.com/rates/js/rates_library.js',
  apq: true,
}
